import React from 'react';
import { X } from 'lucide-react';
import { formatDuration } from '../utils/formatters';

export function NewEntryModal({ form, projects, onChange, onSave, onCancel }) {
  const duration = Math.max(0, new Date(form.endTime).getTime() - new Date(form.startTime).getTime());

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-6 z-50">
      <div className="bg-white rounded-2xl shadow-xl p-6 max-w-md w-full">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-bold text-gray-900">Add Time Entry</h2>
          <button
            onClick={onCancel}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <X size={20} />
          </button>
        </div>
        <div className="space-y-4">
          <div>
            <label className="text-sm text-gray-600 mb-1 block">Description</label>
            <input
              type="text"
              value={form.description}
              onChange={(e) => onChange({ ...form, description: e.target.value })}
              placeholder="What were you working on?"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              autoFocus
            />
          </div>
          <div>
            <label className="text-sm text-gray-600 mb-1 block">Project</label>
            <select
              value={form.projectId}
              onChange={(e) => onChange({ ...form, projectId: e.target.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              {projects.map(project => (
                <option key={project.id} value={project.id}>{project.name}</option>
              ))}
            </select>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="text-sm text-gray-600 mb-1 block">Start Time</label>
              <input
                type="datetime-local"
                value={form.startTime}
                onChange={(e) => onChange({ ...form, startTime: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
              />
            </div>
            <div>
              <label className="text-sm text-gray-600 mb-1 block">End Time</label>
              <input
                type="datetime-local"
                value={form.endTime}
                onChange={(e) => onChange({ ...form, endTime: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
              />
            </div>
          </div>
          <div className="text-sm text-gray-500">
            Duration: {formatDuration(duration)}
          </div>
          <button
            onClick={onSave}
            className="w-full px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
          >
            Add Entry
          </button>
        </div>
      </div>
    </div>
  );
}
